const sendGAEvent = async (eventName, eventParams) => {
    if (window.gtag) {
      await window.gtag('event', eventName, eventParams);
    } else {
      console.warn("Google Analytics gtag.js not loaded");
    }
  }

export default sendGAEvent;